import React from "react";
//import { createNmapScanSchedule, updateNmapScanSchedule } from "./authService";

export const CardTypes = {
    CREATE: "CREATE",
    //EDIT: "EDIT"
}

export class VulscanScheduleCardService {

    constructor(cardType, handleClose) {
        this.cardType = cardType || CardTypes.CREATE;
        this.handleClose = handleClose;
    }

    getHeader = () => {
        return (
            <div className="logo text-center">
                Schedule Nmap Scan
            </div>
        )
    }

    getSubmitButton = (data, disabled) => {

        if (CardTypes.CREATE === this.cardType) {
            return (
                <div className="form-group text-center">
                    <button type="submit" className="btn oct_btn-login" onClick={(e) => {
                        e.preventDefault();
                        this.onCreate(data);
                    }} disabled={disabled}>Create
                    </button>
                </div>
            )
        } else {
            return (
                <>
                    <div className="form-group text-center">
                        <button type="submit" className="btn oct_btn-login" onClick={(e) => {
                            e.preventDefault();
                            this.onSave(data);
                        }} disabled={disabled}>Save
                        </button>
                    </div>                    
                </>
            )
        }
    }

    onCreate = async (data) => {
        //await createUser(data);
        this.handleClose();
    }

    onSave = async (data) => {
        // await updateUser(data);
        this.handleClose();
        // if (data.id === this.loggedUserId) {
        //     //localStorage.removeItem('access_token');
        //     sessionStorage.removeItem('access_token');
        //     window.location.reload();
        // }
    }


}